export { cn } from './classNameHelpers';
export { toast } from './toast';
export { convertUrlParamsToFilters, countActiveFilters, hasFilterValue, mapUrlParamsToApi } from './urlParamsHelpers';

/**
 * IBAN formatting helper function
 * Formats IBAN by adding spaces every 4 characters for better readability
 */
export function formatIBAN(iban: string): string {
    if (!iban) return '';
    iban = iban.replace(/\s+/g, '');
    const groups = iban.match(/.{1,4}/g);
    return groups ? groups.join(' ') : '';
}
